import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { EventScoreboard, KeyValuePairScoreboard, LeaderboardGameScore } from '@frontend/sports/betting-offer/feature/model';

@Component({
    selector: 'ms-leaderboard-game-scoreboard',
    templateUrl: 'leaderboard-game-scoreboard.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, NgFor],
})
export class LeaderboardGameScoreboardComponent {
    @Input() scoreboard: EventScoreboard;
    @HostBinding('class') className = 'leaderboard-game player-info';

    @HostBinding('class.hidden')
    get hidden(): boolean {
        return !this.scoreboard.score;
    }

    get weather(): number {
        if (this.hidden) {
            return -1;
        }

        const score = this.scoreboard.getScore<LeaderboardGameScore>();

        return (score && score.weather) || -1;
    }

    get players(): KeyValuePairScoreboard[] {
        const score = this.scoreboard.score as LeaderboardGameScore;
        if (score.participantsDetails && score.participantsDetails.length > 0) {
            return score.participantsDetails.slice(0, 3);
        }

        return [];
    }
}
